import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Api } from '../Model/api-model';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, timeout } from 'rxjs/operators';
import {AppListResponse} from '../Model/apilistresponse-model';
import {createapp,createappResponse} from '../Model/createappRequest-model';
import { ProductList } from '../Model/productList-model';
import { ApiListDevPortal } from '../Model/apilist-model';
import { MySubRequest } from '../Model/product-model';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})

export class RestApiService {
  
  region;
  
  apiURL;

  smartAppURL;

  //URL1;

  constructor(private http: HttpClient,public router: Router) { 


     this.region = environment.getEnvironment();
   
     this.apiURL = environment.getSpringBootApiUrl();
     this.smartAppURL=environment.getSmartAppURL();
   // this.URL1="https://iopapicdevportalservicesvte-oci-qa.aetapps-qa.aetna.com/iopapicdevportalservicesvte/v1/devportalusers/";
   
  //    this.URL1="http://localhost:8080/v1/devportalusers/";

  }

  /*========================================
    consuming RESTful API
  =========================================*/

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
       // 'id_token':''
    })
  }  



  getQuestionnireData(): Observable<any> {
    return this.http.get<any>(this.apiURL + 'questionnaire',this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

 

  // ThirdPartyDevQuestionnaire Post()method
  ThirdPartyDevQuestionnaire_PostRequest(api): Observable<any> {
    //console.log(JSON.stringify(api));
    return this.http.post<any>(this.apiURL+'questionnaire', JSON.stringify(api), this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }


 // ThirdPartyDevQuestionnaire Post()method
 ThirdPartyDevQuestionnaire_PutRequest(api): Observable<any> {
  //console.log(JSON.stringify(api));
  return this.http.put<any>(this.apiURL+'questionnaire', JSON.stringify(api), this.httpOptions)
  .pipe(
    retry(1),
    catchError(this.handleError)
  )
}


   // CreateApp Post()method
  createApp_PostRequest(api): Observable<createappResponse> {
    //console.log(JSON.stringify(api));
    return this.http.post<createappResponse>(this.apiURL+'app', JSON.stringify(api), this.httpOptions)
    .pipe(
      retry(0),
      timeout(120000),
      catchError(this.handleError)
    )
  }  

   // CreateApp Post()method
   smartApp_PostRequest(app): Observable<any> {
    //console.log(JSON.stringify(api));
    return this.http.post<createappResponse>(this.smartAppURL+'/registration', JSON.stringify(app), this.httpOptions)
    .pipe(
      retry(0),
      catchError(this.handleErrorForSmartApp)
    )
  }  





//deleteApp Post()method
App_deleteRequest(appID): Observable<createappResponse> {
  //console.log(JSON.stringify(app));
  return this.http.delete<any>(this.apiURL+'app/'+appID, this.httpOptions)
  .pipe(
    retry(1),
    catchError(this.handleError)
  )
} 

    // CreateApp Post()method
    updateApp_PutRequest(app,appID): Observable<createappResponse> {
      //console.log(JSON.stringify(app));
      return this.http.put<any>(this.apiURL+'app/'+appID, JSON.stringify(app), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
    }  
    updateAppVerifyClientSecret_PutRequest(app,appID):Observable<createappResponse> {
     // console.log("credital secret"+JSON.stringify(app));
     // console.log("credital secret"+JSON.stringify(app));
     // console.log(this.apiURL+'apps/'+appID+'/credentials/verify-secret');
       return this.http.put<any>(this.apiURL+'app/'+appID+'/credentials/verify-secret',JSON.stringify(app), this.httpOptions)
         .pipe(
           retry(1),
           catchError(this.handleError)
         )
      }
    updateAppResetClientSecret_PutRequest(appID,requestJSON):Observable<createappResponse> {
     // console.log(this.apiURL+'app/'+appID+'/credentials/reset-secret');
       return this.http.put<any>(this.apiURL+'app/'+appID+'/credentials/reset-secret',requestJSON ,this.httpOptions)
         .pipe(
           retry(1),
           catchError(this.handleError)
         )
      }



  // HttpClient API get() method => Fetch app list sample method not for use
  getPublicApis(): Observable<ApiListDevPortal> {
    return this.http.get<ApiListDevPortal>(this.apiURL + 'publicApis',this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

 

  // HttpClient API get() method => Fetch app list sample method not for use
  getProductInfo(productID:string): Observable<any> {
    return this.http.get<any>(this.apiURL + 'product/'+productID,this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  getSmartAppFlag(appID:string): Observable<any> {
    return this.http.get<any>(this.smartAppURL + '/'+appID,this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.payerhandleErrorForSmartApp)
    )
  }

  async getSmartAppFlag_promise(appID:string) {
    return await this.http.get<any>(this.smartAppURL + '/'+appID,this.httpOptions).toPromise();
  }


  mySubscriptionForAnApp(appId:string): Observable<any> {
    return this.http.get<any>(this.apiURL + 'app/'+appId+'/subscriptions',this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }


  async mySubscriptionForAnApp_promise(appID:string) {
    return await this.http.get<any>(this.apiURL + 'app/'+appID+'/subscriptions',this.httpOptions).toPromise();
  }

  mySubscription(): Observable<any> {
    return this.http.get<any>(this.apiURL + 'user/apis',this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }




  unSubscriptionForAnApp(appId:string,subID:string): Observable<any> {
    return this.http.delete<any>(this.apiURL + 'app/'+appId+'/subscription/'+subID,this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }



  // HttpClient API post() method => Create App sample method not for use
  createApis(api): Observable<Api> {
    return this.http.post<Api>(this.apiURL + '/CreateApis', JSON.stringify(api), this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }  


 // HttpClient API post() method => Create App sample method not for use
 emailTrigger(request): Observable<Api> {
  return this.http.post<Api>(this.apiURL+'emailnotification', request, this.httpOptions)
  .pipe(
    retry(1),
    catchError(this.handleError)
  )
}  


  doSubscriptionForAnApp(appId:string,sub:any): Observable<any> {
    return this.http.post<any>(this.apiURL + 'app/'+appId+'/subscription', JSON.stringify(sub), this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }  


 
  


    // HttpClient API get() method => Fetch app list sample method not for use
  getAppList(): Observable<AppListResponse> {
    return this.http.get<AppListResponse>(this.apiURL + 'apps',this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

 
  getPublicProducts(): Observable<ProductList> {
    return this.http.get<ProductList>(this.apiURL + 'public/products',this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }



   // HttpClient API get() method => Fetch app list sample method not for use
   myProfile_Get(): Observable<any> {
    return this.http.get<any>(this.apiURL + 'user',this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  mySwaggerJson_Get(apiID): Observable<any> {
    return this.http.get<any>(this.apiURL + "api/"+apiID,this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }




  
  // Error handling 
  handleError(error) {
     let errorMessage = '';
     const errorCode:string=error.status;
     if(error.error instanceof ErrorEvent) {
       // Get client-side error
   
       errorMessage = error.error.message;
     } else {
       // Get server-side error
       errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
     }
    // window.alert(errorMessage);
 
 
 
    console.log("errorMessage:from:restservices "+errorMessage);
    console.log("errorCode:from:restservices "+errorCode)

   if(errorCode=='401'){
    localStorage.clear();
    console.log("redirect for login")
   
    window.alert("Your Developer Portal session has expired , please login again.");
  
    document.location.href='/dashboard';

   }else{
    window.alert(errorMessage);
   
   }
 
 
 
   return throwError(errorMessage);
  }




  handleErrorForSmartApp(error) {
    let errorMessage = '';
    const errorCode:string=error.status;
    if(error.error instanceof ErrorEvent) {
      // Get client-side error
  
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
   // window.alert(errorMessage);
   if(errorCode=='401'){
    localStorage.clear();
    console.log("redirect for login")
   
    window.alert("Your Developer Portal session has expired , please login again.");
  
    document.location.href='/dashboard';

   }


   console.log("errorMessage:from:restservices "+errorMessage);
   console.log("errorCode:from:restservices "+errorCode)

  


  return throwError(errorMessage);
 }


 payerhandleErrorForSmartApp(error) {
  let errorMessage = '';
  const errorCode:string=error.status;
  if(error.error instanceof ErrorEvent) {
    // Get client-side error

    errorMessage = error.error.message;
  } else {
    // Get server-side error
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
  }
 // window.alert(errorMessage);
 if(errorCode=='401'){
  localStorage.clear();
  console.log("redirect for login")
 
//  window.alert("Your Developer Portal session has expired , please login again.");

 // document.location.href='/dashboard';

 }


 console.log("errorMessage:from:restservices "+errorMessage);
 console.log("errorCode:from:restservices "+errorCode)




return throwError(errorMessage);
}




}